// hooks/useDeliveries.js
import { useState, useEffect, useCallback } from 'react';
import { deliveryApi } from '../api/deliveries';
import toast from 'react-hot-toast';

export const useDeliveries = () => {
  const [deliveries, setDeliveries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDeliveries = useCallback(async () => {
    setLoading(true);
    try {
      const response = await deliveryApi.getAll();
      setDeliveries(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      toast.error('Failed to fetch deliveries');
    } finally {
      setLoading(false);
    }
  }, []);

  const addDelivery = useCallback(async (data) => {
    try {
      const response = await deliveryApi.create(data);
      toast.success('Delivery added successfully!');
      await fetchDeliveries();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add delivery');
      throw err;
    }
  }, [fetchDeliveries]);

  const updateDelivery = useCallback(async (id, data) => {
    try {
      const response = await deliveryApi.update(id, data);
      toast.success('Delivery updated successfully!');
      await fetchDeliveries();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update delivery');
      throw err;
    }
  }, [fetchDeliveries]);

  const deleteDelivery = useCallback(async (id) => {
    try {
      await deliveryApi.delete(id);
      toast.success('Delivery deleted successfully!');
      await fetchDeliveries();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to delete delivery');
      throw err;
    }
  }, [fetchDeliveries]);

  useEffect(() => {
    fetchDeliveries();
  }, [fetchDeliveries]);

  return { deliveries, loading, error, fetchDeliveries, addDelivery, updateDelivery, deleteDelivery };
};